import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'
import { httpHandler, safeAwait } from '@vzmi/component_ec_nodejs_util/dist/lib/FetchDataUtil'
import SellerLogin from '../../../components/Seller/Login'
import {
  fetchWssid,
  fetchSeCookie,
  setErrorBoundaryError
} from '../../../actions'
import appConf from '../../../../../conf/appConf'
import authUtil from '../../../../lib/authUtil'
import confUtil from '../../../../lib/confUtil'
import errorHelper from '../../../../lib/errorHelper'

const mapStateToProps = (state, ownProps) => {
  return {
    page: state.page
  }
}

const mapDispatchToProps = (dispatch) => {
  const actions = {}

  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

const COOKIE_CONFIG = {
  // 10 hours
  maxAge: 10 * 60 * 60 * 1000,
  domain: 'supplier.yahoo.com',
  httpOnly: true,
  secure: true,
  encode: String
}

const OKTA_COOKIES = [
  appConf.oktaAtCookieKey,
  appConf.oktaItCookieKey
]

const DEFAULT_ERROR = {
  code: 'UNEXPECT_SELLER_LOGIN_ERROR',
  message: '無法取得店家登入資訊'
}

// Overrides default preFetcher in app.server.js
SellerLogin.preFetcher = async ({ store, req, res }) => {
  const sellerId = _.get(req, 'query.sellerId')
  const isSellerIdEmpty = _.isEmpty(sellerId)
  const envConf = _.get(store.getState(), 'page.envConf', {})
  const { isMallReferer, isYCookie, isOktaCookie } = authUtil(req)
  // 有 okta cookie 沒有 se cookie 就導到模擬登入
  if (isSellerIdEmpty && isOktaCookie) {
    res.redirect(confUtil.getAbsUrl(envConf)('sellerSimulateLogin'))
    return Promise.resolve()
  }

  // 沒有 seller id 或是 yahoo YT & okta cookie 都沒有就導到店家後台登入頁
  if (isSellerIdEmpty || (!isYCookie && !isOktaCookie)) {
    res.redirect(confUtil.getAbsUrl(envConf)('sellerLogin'))
    return Promise.resolve()
  }

  // 從店家後台登入時，清除 okta cookie 確保身份非模擬登入
  if (isMallReferer) {
    for (const cookieKey of OKTA_COOKIES) {
      res.clearCookie(cookieKey, _.omit(COOKIE_CONFIG, ['maxAge']))
    }
  }

  const [cookieError, result] = await safeAwait(
    store.dispatch(fetchSeCookie({ sellerId })).then(httpHandler)
  )
  // 取 cookie 失敗導向判斷根據 api error code
  if (cookieError) {
    // 403, 404 顯示錯誤頁
    if (cookieError.code === 'UNAUTHORIZED') {
      store.dispatch(setErrorBoundaryError(cookieError, cookieError))
      return Promise.resolve()
    }

    const apiError = _.get(cookieError, 'errorObjects[0]', DEFAULT_ERROR)
    const { url } = errorHelper.getRedirectObjectByError({ error: apiError, req })
    // 有 url 則導向 url
    if (!_.isEmpty(url)) {
      res.redirect(url)
      return Promise.resolve()
    }

    // api error 顯示錯誤頁
    store.dispatch(setErrorBoundaryError(apiError, cookieError))
    return Promise.resolve()
  }

  // 取 cookie 成功寫入 _se cookie & 導向 dashboard
  res.cookie(appConf.seCookieKey, result.cookie, COOKIE_CONFIG)
  res.redirect(`${appConf.sellerWebUrlPath}/dashboard`)

  return Promise.resolve(store.dispatch(fetchWssid()))
}

SellerLogin.fetchData = async ({
  store,
  req,
  res,
  match
}) => {
  try {
    const tasks = []
    return Promise.all(tasks)
  } catch (e) {
    throw e
  }
}

const MappedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(SellerLogin)

export default MappedComponent
